<template>
  <div>
    <header-wrap></header-wrap>
    <secord-nav></secord-nav>
    <div class="area_title">
      <h1>{{ applicationAreaPage.title }}</h1>
      <div class="breadcrumb_wrap">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">{{ navbar.home }}</el-breadcrumb-item>
          <el-breadcrumb-item>
            <span class="is-link" @click="onNav()">{{ navbar.applicationArea }}</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item v-if="activeNameText !== ''">
            {{ activeNameText }}
          </el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="area_cation">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in appList"
          :label="item[`${currentLang.prefix}cate_name`]"
          :name="index + ''"
          :key="index"
        ></el-tab-pane>
      </el-tabs>
    </div>

    <template v-if="activeName === '-1'">
      <div class="area_main">
        <h2>{{ applicationAreaPage.titleOne }}</h2>
        <p>
          {{ applicationAreaPage.contentOne }}
        </p>
      </div>
      

      <div class="area_every">
        <div class="area_li" v-for="(item, index) in appList" :key="index" >
          <template v-if="index%2 === 0">
            <img :src="item.full_image" alt="" />
            <div class="li_right li_content">
              <h2>{{item[`${currentLang.prefix}cate_name`]}}</h2>
              <p>
                {{item[`${currentLang.prefix}summary`]}}
              </p>
              <div class="dynamic_btn" @click="changeTab(index, item)">
                <span>MORE</span>
                <img
                  class="more_btn"
                  src="../../assets/images/public/arrow1.png"
                  alt=""
                />
              </div>
            </div>
          </template>
          <template v-if="index%2 === 1">
            <div class="li_left li_content">
              <div class="left_box">
                <h2>{{item[`${currentLang.prefix}cate_name`]}}</h2>
                <p>
                  {{item[`${currentLang.prefix}summary`]}}
                </p>
                <div class="dynamic_btn" @click="changeTab(index, item)">
                  <span>MORE</span>
                  <img
                    class="more_btn"
                    src="../../assets/images/public/arrow1.png"
                    alt=""
                  />
                </div>
              </div>
            </div>
            <img :src="item.full_image" alt="" />
          </template>
        </div>
      </div>
    </template>

    <template v-else>
      <Yyly1 :detailsId="detailsId"></Yyly1>
    </template>
    
    <footer-wrap></footer-wrap>
  </div>
</template>

<script>
import { getCateListApplication } from "@/utils/http.js";
import { mapGetters } from 'vuex'
import Yyly1 from "./yyly1.vue";

export default {
  inject: ['reload'],

  components: {
    Yyly1
  },
  data() {
    return {
      activeNameText: "",
      activeName: "-1",
      appList: [],
      detailsId:'',
    };
  },

  computed: {
    ...mapGetters([
      'currentLang'
    ]),
    applicationAreaPage() {
      return this.currentLang.config.applicationAreaPage
    },
    navbar() {
      return this.currentLang.config.navbar
    },
  },

  created() {
    this.getAppList();
    if(this.$route.query.index){
	  	this.activeName=this.$route.query.index;
	  	this.detailsId= this.$route.query.detailsId ? this.$route.query.detailsId : '';
	  }
    if (this.$route.query.label) {
      this.activeNameText = this.$route.query.label
    }
  },
  mounted() {

  },
  methods: {
    onNav() {
      this.$set(this, 'activeName', '-1')
      this.$set(this, 'detailsId', '')
      this.$set(this, 'activeNameText', '')
    },

    getAppList() {
      getCateListApplication().then(res => {
        console.log(res);
        if (res.code === 1) {
          this.appList = res.data;
        }
      });
    },
    handleClick(tab) {
	  // console.log('tab.index',tab.index)	
      this.activeName = tab.index
      this.activeNameText = tab.label;
      this.appList.forEach((item,index) => {
        if(index + '' === tab.index){
          this.detailsId = item.id
          
        }
      });
      this.$router.push({
        path: 'yyly',
        query: {
          index: this.activeName,
          label: this.activeNameText,
          detailsId: this.detailsId
        }
      })
      this.reload()
    },
    changeTab(index, info) {
      this.activeName = index + ''
      this.detailsId = info.id
      this.activeNameText = info.cate_name
      /* this.$router.push({
        path: 'yyly',
        query: {
          index: this.activeName,
          label: this.activeNameText,
          detailsId: this.detailsId
        }
      })
      this.reload() */
    }
  },
};
</script>
<style lang="scss" scoped>
.area_title {
  width: 100%;
  height: 160px;
  line-height: 160px;
  background: url("../../assets/images/public/i12.jpg") no-repeat;
  background-size: 100% 100%;
  background-size: cover;
  background-position: center center;
  text-align: center;
  position: relative;
  h1 {
    color: white;
    font-weight: normal;
  }
  .breadcrumb_wrap {
    width: 1200px;
    position: absolute;
    top: 15px;
    left: calc(50% - 600px);
    /deep/ .el-breadcrumb__item {
      span {
        color: #fff;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}

.area_cation {
  display: flex;
  justify-content: center;
  /deep/ .el-tabs {
    width: 100%;
    .el-tabs__header {
      height: 60px;
      line-height: 60px;
      background: #4b4b4b;
      border: 0;
      // width: 1200px;
      margin: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      .el-tabs__nav-wrap {
        height: 100%;
        margin-bottom: 0;
        .el-tabs__nav-scroll {
          height: 100%;
          .el-tabs__nav {
            height: 100%;
            border: 0;
            .el-tabs__item {
              height: 100%;
              color: #979797;
              border-left: none;
              border-bottom: none;
              padding: 0 25px;
              line-height: unset;
              font-size: 16px;
            }
            .is-active {
              background: #646464;
            }
          }
        }
      }
    }
  }
}

.area_main {
  width: 1200px;
  height: auto;
  margin: 60px auto;
  background: white;
  text-align: center;
  line-height: 1.8;

  h2 {
    color: #323232;
    font-weight: normal;
    margin-bottom: 30px;
    font-size: 30px;
  }

  p {
    color: #777777;
    font-size: 18px;
  }
}

.area_every {
  width: 100%;
  height: auto;
  background: #f5f5f5;
}

.area_li {
  display: flex;
  max-height: 550px;
  min-height: 500px;

  img {
    width: 50%;
    object-fit: cover;
    object-position: center;
  }

  .li_content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .li_right {
    width: 50%;
    background: #f5f5f5;
    // padding: 0 50px;

    h2 {
      width: 60%;
      color: #003258;
      font-weight: normal;
      margin: 0 0 30px 110px;
    }

    p {
      min-height: 210px;
      width: 60%;
      margin: 0 0 0px 110px;
      color: #777777;
      line-height: 1.8;
      text-align: justify;
      font-size: var(--text-size-bit-larger);
    }

    .dynamic_btn {
      width: 140px;
      height: 45px;
      background: #e8363e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin: 40px 0 0 110px;
      cursor: pointer;
      .more_btn {
        width: 40px;
        margin-left: 10px;
      }
    }
  }

  .li_left {
    align-items: flex-end;
    width: 50%;
    background: #f5f5f5;

    .left_box {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 60%;
      height: 100%;
      margin-right: 110px;
    }

    h2 {
      width: 100%;
      color: #003258;
      font-weight: normal;
      margin: 0px 0 30px 0;
    }

    p {
      min-height: 210px;
      width: 100%;
      color: #777777;
      line-height: 1.8;
      text-align: justify;
      font-size: var(--text-size-bit-larger);
    }

    .dynamic_btn {
      width: 140px;
      height: 45px;
      background: #e8363e;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      margin: 40px 0 0 0;
      cursor: pointer;
      .more_btn {
        width: 40px;
        margin-left: 10px;
      }
    }
  }
}

// .el-tabs__nav-wrap {
//   margin-bottom: 0;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__nav {
//   border: 0;

// }

// .el-tabs--card>.el-tabs__header {
//   border: 0;
//   width: 1200px;
//   margin: auto;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__item {
//   border-left: 0;
//   border-bottom: 0;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__item.is-active {
//   background: #646464;
// }

// .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:nth-child(2) {
//   padding-left: 50px;
// }

// .el-tabs--top.el-tabs--card>.el-tabs__header .el-tabs__item:last-child {
//   padding-right: 50px;
// }

// .el-tabs__item {
//   height: 40px;
//   color: gray;
//   padding: 0 50px;
// }

// .el-tabs__item.is-active {
//   color: white;
// }

// .el-tabs__nav-wrap {
//   height: 40px;
// }

// .el-tabs__item:hover {
//   color: gray;
// }

// .el-tabs--card>.el-tabs__header .el-tabs__item.is-active:hover {
//   color: white;
// }
</style>



// WEBPACK FOOTER //
// src/pages/yyly/yyly.vue